module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0095.png.5c4c02e5.jpg";